export enum AmagnoStorageKeyEnum {
    PANELS = 'PANELS',
    RECENT_TAG_VALUES = 'RECENT_TAG_VALUES',
    SERVERS = 'SERVERS',
    THEME = 'THEME',
    RECENT_SEARCHES = 'RECENT_SEARCHES',
    IGNORE_LANDSCAPE_WARNING = 'IGNORE_LANDSCAPE_WARNING',
}
